import React, { FC }                                        from 'react';
import classNames                                           from 'classnames';
import { ClassValue }                                       from 'classnames/types';
import { FlexAlign, FlexJustify, FlexFlow, FlexGutterSize } from '../../types';

export interface FlexboxProps {
	className?: ClassValue,
	justify?: FlexJustify,
	align?: FlexAlign,
	direction?: FlexFlow,
	cols?: 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | number,
	gutterSize?: FlexGutterSize,
	noWrap?: boolean,
	
	[ additionalProps: string ]: any
}

const defaultProps: FlexboxProps = {
	className:  null,
	justify:    FlexJustify.SPACE_BETWEEN,
	align:      FlexAlign.START,
	noWrap:     null,
	direction:  null,
	cols:       null,
	gutterSize: null,
};

const Flexbox: FC<FlexboxProps> = ( props ) => {
	
	let { children, className, justify, align, noWrap, direction, cols, gutterSize, ...p } = props;
	
	let classes = classNames(
		'flexbox', {
			[ `flexbox--justify-${ justify }` ]:    justify,
			[ `flexbox--align-${ align }` ]:        align,
			[ `flexbox--nowrap` ]:                  noWrap,
			[ `flexbox--cols` ]:                    ( direction === FlexFlow.COLS ),
			[ `flexbox--row-reverse` ]:             ( direction === FlexFlow.ROW_REVERSE ),
			[ `flexbox--cols-reverse` ]:            ( direction === FlexFlow.COLS_REVERSE ),
			[ `flexbox--cols-${ cols }` ]:          cols,
			[ `flexbox--${ gutterSize }-gutters` ]: gutterSize,
		},
		className
	);
	
	return (
		<div className={ classes } { ...p }>
			{ children }
		</div>
	);
};

Flexbox.defaultProps = defaultProps;

export { Flexbox };
